<template>
  <el-container>
    <el-main v-if="venues">
      <el-row type="flex" justify="space-start" :gutter="30">

        <!-- Create New -->

        <el-col :span="8">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Create Venue</h4>
            </div>
            <div class="card-content">
              <el-form :model="venue" :rules="rules" ref="venue" label-width="120px" class>
                <el-form-item label="Name" prop="name">
                  <el-input v-model="venue.name"></el-input>
                </el-form-item>
                <el-form-item label="Address" prop="address1">
                  <el-input v-model="venue.line1"></el-input>
                </el-form-item>
                <el-form-item label prop="address2">
                  <el-input v-model="venue.line2"></el-input>
                </el-form-item>
                <el-form-item label="Town" prop="town">
                  <el-input v-model="venue.town"></el-input>
                </el-form-item>
                <el-form-item label="Post Code" prop="postalCode">
                  <el-input v-model="venue.postcode"></el-input>
                </el-form-item>
                <el-form-item label="Country" prop="country">
                  <el-select v-model="venue.country" placeholder="Country">
                    <el-option
                      v-for="(country,index) in countries"
                      class="select-default"
                      :value="country"
                      :label="index"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Email" prop="email" size="mini">
                  <el-input v-model="venue.email"></el-input>
                </el-form-item>
                <el-form-item label="Phone" prop="telno" size="mini">
                  <el-input v-model="venue.phone"></el-input>
                </el-form-item>
                <el-form-item label="Website" prop="website" size="mini">
                  <el-input v-model="venue.website"></el-input>
                </el-form-item>
                <el-form-item label="Latitude" prop="latitude" size="mini">
                  <el-input v-model="venue.lat"></el-input>
                </el-form-item>
                <el-form-item label="Longitude" prop="longitude" size="mini">
                  <el-input v-model="venue.long"></el-input>
                </el-form-item>
                <el-form-item>
                  <p>You can get the lat and long by clicking <a href="https://www.latlong.net/convert-address-to-lat-long.html"  target="_blank">here</a></p>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="createVenue('venue')">Create</el-button>
                  <el-button @click="resetForm('venue')">Reset</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>

        <!-- List Existing -->

        <el-col :span="16">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Venues List</h4>
            </div>
            <div class="card-content">

              <!--
                <el-card shadow="never" :body-style="{ background: '#f5f5f5' }">
                Filter by Country and Town
                <br>
                <el-select
                  v-model="listQuery.country"
                  size="mini"
                  class="form-group border-input"
                  placeholder="Select Country"
                  @change="getTownsByCountry"
                >
                  <el-option
                    v-for="(country,index) in countries"
                    class="select-danger"
                    :value="country"
                    :label="index"
                    :key="index"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="listQuery.town"
                  size="mini"
                  class="form-group border-input"
                  placeholder="Select Town"
                  @change="getVenues"
                >
                  <el-option
                    v-for="(town,index) in towns"
                    class="select-danger"
                    :value="town"
                    :label="town"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-card>
              <el-pagination
                v-if="total>listQuery.limit && total>0"
                background
                layout="total, sizes, prev, pager, next"
                :current-page.sync="listQuery.page"
                :total="total"
                :page-size.sync="listQuery.limit"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                @size-change="getVenues"
                @current-change="getVenues"
              ></el-pagination>
              -->



              <div class="table-responsive">

              <el-row style="margin-top:30px; margin-bottom: 10px">

                <el-col :span="5">
                  <label class="control-label">Country:</label><br>
                  <el-select
                    v-model="filters[0].value"
                    size="mini"
                    class="form-group border-input"
                    placeholder="Select Country"
                    @change="getTownsByCountry(filters[0].value)"
                  >
                    <el-option value="All" label="All"></el-option>
                    <el-option
                      v-for="(country,index) in countries"
                      class="select-danger"
                      :value="country"
                      :label="index"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-col>

                <el-col :span="5">
                  <label class="control-label">Town:</label><br>
                  <el-select
                    v-model="filters[1].value"
                    size="mini"
                    class="form-group border-input"
                    placeholder="Select Town"
                    @change="getVenues"
                  >
                    <el-option value="All" label="All"></el-option>
                    <el-option
                      v-for="(town,index) in towns[filters[0].value]"
                      class="select-danger"
                      :value="town"
                      :label="town"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-col>

                <el-col :span="5">
                  <label class="control-label">Status:</label><br>
                  <el-select
                    v-model="filters[2].value"
                    size="mini"
                    class="form-group border-input"
                    placeholder="Select Status"
                    @change="getVenues"
                  >
                    <el-option label="Any status" value="2"></el-option>
                    <el-option label="Only Active" value="0"></el-option>
                    <el-option label="Only Inactive" value="1"></el-option>
                  </el-select>
                </el-col>
                
              </el-row>



            <data-tables-server 
              class="table-shopping" 
              style="width: 100%" 
              :data="venues" 
              :tool-bar="false" 
              :current-page="1" 
              :total="total"
              :loading="loadingVenues"
              :page-size="20"
              @query-change="getVenues"
              :filters="filters"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                <el-table-column label="Name" min-width="330">
                  <template slot-scope="props">{{props.row.name}}</template>
                </el-table-column>

                <el-table-column label="Town" min-width="130">
                  <template slot-scope="props">{{props.row.town}}</template>
                </el-table-column>

                <el-table-column label="Active" min-width="100">
                  <template slot-scope="props">
                    <small
                      class="label label-success"
                      v-if="!props.row.historic"
                    >Yes</small>
                    <small
                      class="label label-danger"
                      v-else
                    >No</small>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Country"
                  min-width="130"
                  sortable="custom"
                  prop="country"
                >
                  <template slot-scope="props">
                    <span v-if="props.row.country">{{props.row.country}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="Edit" class="td-text">
                  <template slot-scope="props">
                    <router-link :to="'/classroom/venue/edit/' +props.row.id">Edit</router-link>
                  </template>
                </el-table-column>
            </data-tables-server>



            </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
import { commonApi } from "../../api/common.js";
import json from "../../data/countries.json";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      loadingVenues: false,
      venue: {
        name: "",
        contactName: "",
        town: "",
        line1: "",
        line2: "",
        postcode: "",
        country: "",
        email: "",
        phone: "",
        website: "",
        dateCreated: moment().format(),
        dateUpdated: moment().format(),
        letterText: "",
        mapGraphic: "",
        historic: "0",
        lat: "0.0",
        long: "0.0"
        
      },
      venues: [],
      filters: [
        {
          value: "All",
          prop: "country",
        }, 
        {
          value: "All",
          prop: "town"
        },
        {
          value: "0",
          prop: "historic",
        }
      ],
      total: 0,
      countries: json,
      towns: 
        {
          EN: [],
          SS: [],
          WA: [],
          IE: [],
          ND: [],
          US: [],
          ES: []
        }
      ,
      listQuery: {
        filterBy: "id",
        page: 0,
        limit: 20,
        skip: 0,
        orderBy: "country",
        orderDirection: "DESC",
        town: "All",
        country: "All"
      },
      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" }
        ],
        town: [
          { required: true, message: "Please add town", trigger: "change" }
        ],
        country: [
          { required: true, message: "Please add country", trigger: "change" }
        ],
        email: [
          {
            type: "email",
            required: false,
            message: "Please input correct email address",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {

    async getVenues(queryInfo) {

      console.log('getVenues: ', queryInfo)

      if ( queryInfo != undefined && typeof queryInfo === 'object' ) {

        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'asc_nulls_last';
        var orderProp = 'id';

        (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort') //&&
        //this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`)

        
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        } else {}
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }

      } else {

        var type = 'init';
        var page = 1;
        var pageSize = 20;
        var orderDir = 'asc_nulls_last';
        var orderProp = 'id';

      }

      var equalCountry = this.filters[0].value === "All" ? "_neq" : "_eq"
      var equalTown = this.filters[1].value === "All" ? "_neq" : "_eq"
      var equalStatus = this.filters[2].value === "2" ? "_lte" : "_eq"

      this.loadingVenues = true;

      this.$apollo
      .query({
        query: gql`
        {
          ClassRoomVenue(
            limit: ${pageSize}, 
            offset: ${(page - 1) * pageSize}, 
            order_by: {${orderProp}: ${orderDir}},
            where: { 
              _and: [
                { country: {${equalCountry}: "${this.filters[0].value}"} },
                { town: {${equalTown}: "${this.filters[1].value}"} },
                { historic: {${equalStatus}: "${this.filters[2].value}"} }
              ]
            }
          ) {
            id
            phone
            country
            line1
            line2
            town
            region
            postcode
            name
            website
            email
            contactName
            dateCreated
            dateUpdated
            lat
            long
            historic
          }
          ClassRoomVenue_aggregate(
            where: { 
              _and: [
                { country: {${equalCountry}: "${this.filters[0].value}"} },
                { town: {${equalTown}: "${this.filters[1].value}"} },
                { historic: {${equalStatus}: "${this.filters[2].value}"} }
              ]
            }
          ) {
            aggregate {
              count
            }
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.venues = response.data.ClassRoomVenue;
        this.total = response.data.ClassRoomVenue_aggregate.aggregate.count;
        //this.towns = response.data.ClassRoomVenue.town;
        this.loadingVenues = false;
      });
    },

    getTownsByCountry(country) {
      if (country != 'All') {
        if (this.towns[country].length === 0) {
        this.$apollo
          .query({
            query: gql`
            {
              ClassRoomVenue(
                order_by: {town: asc},
                where: { country: {_eq: "${country}"} }
              ) {
                town
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
          })
          .then(response => {
            for (let venue of response.data.ClassRoomVenue) {
                this.towns[country].push(venue.town);
            }
            this.towns[country] = this.towns[country].filter(function(item, i, ar){ return ar.indexOf(item) === i; });
            this.filters[1].value = 'All'
            //return this.towns[country]
          });
        } else {
          this.filters[1].value = 'All'
          //return this.towns[country]
        }
      } else {
        this.getVenues();
      }
    },

    sortChange(data) {
      if (data.prop) {
        this.listQuery.orderBy = data.prop;
        if (data.order == "ascending") {
          data.order = "ASC";
        } else {
          data.order = "DESC";
        }
        this.listQuery.orderDirection = data.order;
      }
      this.getVenues();
    },

    createVenue(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          
          
            const q = gql`
            mutation insert_classroomvenue(
              $name: String,
              $contactName: String,
              $town: String,
              $line1: String,
              $line2: String,
              $postcode: String,
              $country: String,
              $email: String,
              $phone: String,
              $website: String,
              $dateCreated: timestamp,
              $dateUpdated: timestamp,
              $letterText: String,
              $mapGraphic: String,
              $historic: smallint,
              $lat: float8,
              $long: float8
            ) {
              insert_ClassRoomVenue(objects: {
                name: $name,
                contactName: $contactName,
                town: $town,
                line1: $line1,
                line2: $line2,
                postcode: $postcode,
                country: $country,
                email: $email,
                phone: $phone,
                website: $website,
                dateCreated: $dateCreated,
                dateUpdated: $dateUpdated,
                letterText: $letterText,
                mapGraphic: $mapGraphic,
                historic: $historic,
                lat: $lat,
                long: $long
              }) {
                affected_rows
                returning {
                  id
                  name
                }
              }
            }

            `

            this.$apollo

            .mutate({
              mutation: q,
              variables: {
                name: this.venue.name,
                contactName: this.venue.contactName,
                town: this.venue.town,
                line1: this.venue.line1,
                line2: this.venue.line2,
                postcode: this.venue.postcode,
                country: this.venue.country,
                email: this.venue.email,
                phone: this.venue.phone,
                website: this.venue.website,
                dateCreated: this.venue.dateCreated,
                dateUpdated: this.venue.dateUpdated,
                letterText: this.venue.letterText,
                mapGraphic: this.venue.mapGraphic,
                historic: this.venue.historic,
                lat: this.venue.lat,
                long: this.venue.long
              }
            })

            .then(result => {
              this.$notify({
                title: "Create new venue",
                message: "New venue created",
                type: "success"
              })
            })
            .catch(error => {
              this.$notify({
                title: "Error",
                message: error.message,
                type: "error"
              })
            })
          


        } else {
          this.$notify({
            title: "Error Creating Venue",
            message: "Please check you have filled in the correct items",
            duration: 0,
            type:'error'
          });
          return false;

        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }

  },
  mounted() {
    this.getVenues();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Classrooms/Venues.vue